import React from "react";
import { bonuses } from "../data/bonuses";
export function BundleShowcase() {
  return <section className="bg-linen py-20 md:py-28" aria-labelledby="bundle-title" data-id="element-43" data-mp="3l52ah3cax8ji">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[1.35fr_1fr]" data-id="element-44" data-mp="3q4opnibowyuy">
        <div className="relative" data-id="element-45" data-mp="3uveu8tcakxol">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/9833ea28-d691-4aaa-bcfa-26fa7c1ada3c.jpg" alt="Guide Théorique du Professeur et Guide Pratique d'Exercices posés devant un piano" className="w-full rounded-2xl object-cover shadow-[0_30px_60px_-24px_rgba(63,39,23,0.5)]" data-id="element-46" data-mp="3uwggltyrd6lm" />
          <div className="absolute -bottom-8 left-4 w-60 rounded-xl bg-walnut p-5 text-linen shadow-xl sm:left-8" data-id="element-47" data-mp="cnpakp10p5wg">
            <p className="font-serif text-lg" data-id="element-48" data-mp="2eh553x0874wp">
              5 bonus <span className="italic text-brass" data-id="element-49" data-mp="2eipyvkepujti">exclusifs</span>
            </p>
            <ul className="mt-3 space-y-1.5 text-xs text-sand" data-id="element-50" data-mp="2jhb11pdj3dkl">
              {bonuses.map(b => <li key={b.number} className="flex gap-2" data-id="element-51" data-mp="2f83wv2znnxff">
                  <span className="font-semibold text-brass" data-id="element-52" data-mp="2agc7gvs8jxqv">{b.number}</span>
                  <span className="truncate" data-id="element-53" data-mp="2ae96xhtgim7w">{b.title}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 lg:pt-0" data-id="element-54" data-mp="21g77v7taa3n9">
          <span className="inline-block rounded-full bg-sand px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-walnut" data-id="element-55" data-mp="21hidzea7bnhj">
            Le Pack Prof de Piano + 5 bonus
          </span>
          <h2 id="bundle-title" className="mt-6 font-display text-4xl uppercase leading-none text-ink md:text-5xl" data-id="element-56" data-mp="2t7mtozn0nmcf">
            Deux guides. Un système complet.
          </h2>
          <p className="mt-6 font-serif text-lg leading-relaxed text-stone" data-id="element-57" data-mp="2k89hhz7icjo0">
            Fini l'improvisation. Avec la théorie organisée de votre côté et des exercices
            prêts à distribuer, chaque cours a un objectif clair et chaque élève sait
            exactement quoi travailler à la maison.
          </p>
          <dl className="mt-8 grid grid-cols-3 border-t border-walnut/15 pt-6" data-id="element-58" data-mp="1f78iwebxtyee">
            <div data-id="element-59" data-mp="1f55ufyqfodbs">
              <dt className="text-xs text-stone" data-id="element-60" data-mp="117hbiwfxfg9d">Exercices</dt>
              <dd className="font-display text-3xl text-walnut" data-id="element-61" data-mp="1177jz4f8h11k">150+</dd>
            </div>
            <div data-id="element-62" data-mp="157hoecndnjeb">
              <dt className="text-xs text-stone" data-id="element-63" data-mp="15b5l1ko4clx9">Niveaux</dt>
              <dd className="font-display text-3xl text-walnut" data-id="element-64" data-mp="rgmnbmj4e6la">3</dd>
            </div>
            <div data-id="element-65" data-mp="w8nw2yh2xf6k">
              <dt className="text-xs text-stone" data-id="element-66" data-mp="w962up1dbbsq">Bonus</dt>
              <dd className="font-display text-3xl text-walnut" data-id="element-67" data-mp="hjrqr96eqg9n">5</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>;
}